export var DeviceTaskExecutionResult;
(function (DeviceTaskExecutionResult) {
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["ControllerResponseTimeout"] = -4] = "ControllerResponseTimeout";
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["DeviceNotFound"] = -3] = "DeviceNotFound";
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["DeviceResponseTimeout"] = -2] = "DeviceResponseTimeout";
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["Failed"] = -1] = "Failed";
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["Unknown"] = 0] = "Unknown";
    DeviceTaskExecutionResult[DeviceTaskExecutionResult["Executed"] = 1] = "Executed";
})(DeviceTaskExecutionResult || (DeviceTaskExecutionResult = {}));
//# sourceMappingURL=TaskExecutionResult.js.map